export const mapCenterCalculate = (discount) => {
  const totalWidth = window.innerWidth;
  const remainingWidth = (totalWidth - discount) / 5;

  return remainingWidth;
};
